import Vue from 'vue'
import initialState from './defaultState'

export default {
    resetStateMutation(state) {
        const defaultState = initialState();

        Object.keys(state).forEach(item => {
            Vue.set(state, item, defaultState[item]);
        })
    }
}
